import { Component } from "react";
import { connect } from "react-redux";
import AbsenceForm from "./AbsenceForm";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

class ValidateAbsence extends Component {
    constructor(props) {
        super(props);

        if (props.absences.absenceDetails.length === 0) props.history.push("/absences");
    }

    render() {
        return <AbsenceForm readonly={true} />;
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ValidateAbsence);
